import React from 'react';
import { Card, CardSection } from '@axiom/ui';
import type { Candidate, CandidateWorkFeedItem } from '@axiom/validation';

import type { WorkFeedViewsType } from '../../utils/WorkFeedUtil';

import { WorkFeedCardHeader } from './WorkFeedCardHeader';
import { WorkFeedCardBadges } from './WorkFeedCardBadges';
import { WorkFeedCardMessages } from './WorkFeedCardMessages';
import { WorkFeedCardDataPoints } from './WorkFeedCardDataPoints';
import { WorkFeedCardJobDescription } from './WorkFeedCardJobDescription';
import { WorkFeedCardFooter } from './WorkFeedCardFooter';

export const WorkFeedCard = ({
  candidate,
  workFeedItem,
  view,
  index,
  name = 'WORK_FEED_CARD',
}: {
  candidate: Candidate;
  workFeedItem: CandidateWorkFeedItem;
  view: WorkFeedViewsType;
  index: number;
  name?: string;
}) => {
  const cardName =
    index === 0 ? 'OPPORTUNITY_FEED_FIRST_CARD' : 'OPPORTUNITY_FEED_CARD';

  return (
    <div data-test={name}>
      <Card name={cardName}>
        <WorkFeedCardHeader
          name="WORK_FEED_CARD_HEADER"
          workFeedItem={workFeedItem}
          view={view}
        />
        <CardSection divider>
          <WorkFeedCardBadges
            name="WORK_FEED_CARD_BADGES"
            workFeedItem={workFeedItem}
          />
          <WorkFeedCardMessages
            name="WORK_FEED_CARD_MESSAGES"
            workFeedItem={workFeedItem}
            candidate={candidate}
          />
          <WorkFeedCardDataPoints
            name="WORK_FEED_CARD_DATA_POINTS"
            workFeedItem={workFeedItem}
            index={index}
          />
          <WorkFeedCardJobDescription
            name="WORK_FEED_CARD_JOB_DESCRIPTION"
            workFeedItem={workFeedItem}
            view={view}
          />
        </CardSection>
        <WorkFeedCardFooter
          name="WORK_FEED_CARD_FOOTER"
          workFeedItem={workFeedItem}
          view={view}
          candidate={candidate}
        />
      </Card>
    </div>
  );
};
